<div class="options-board">
	<div class="header">
		<app-options-board-header
			(changeFilters)="onChangeFilters($event)"
			[liveTicker]="liveTicker()"
		/>
	</div>
	<div class="table">
		<app-options-board-table
			[widget]="widget()"
			[liveTicker]="liveTicker()"
			[options]="options()"
			[isLoadingOptions]="isLoadingOptions()"
			[isLoadingTop]="isLoadingTop()"
			[isLoadingBottom]="isLoadingBottom()"
			[isPoolScrollTrigger]="isPoolScrollTrigger()"
			(reqOptionsByNextUrl)="getOptionsByNextUrl($event)"
		/>
	</div>
</div>
